'use strict';

angular.module('inara').factory('StateLoggerService', StateLoggerService);

var log = require('../../log/Log').channel('StateLoggerService');

StateLoggerService.$inject = ['$rootScope'];

function StateLoggerService($rootScope) {
    log.info('initializing');

    $rootScope.$on('$stateChangeStart', onStateChangeStart);

    function onStateChangeStart(event, toState, toParams, fromState, fromParams) {
        log.debug(fromState.name + ' ' + JSON.stringify(fromParams) + ' -> ' + 
                  toState.name + ' ' + JSON.stringify(toParams));
    }
    
    return {};
}

module.exports = StateLoggerService;
